module.exports = __webpack_public_path__ + "img/bul_history_time.4957647a.svg";